import { Construction, ArrowLeft } from "lucide-react";
import { Link } from "wouter";
import { AppLayout } from "@/components/layout/AppLayout";
import { roleHomes, useDemoStore } from "@/store/useDemoStore";

interface ComingSoonProps {
  title: string;
  description?: string;
  module: string;
}

export default function ComingSoon({ title, description, module }: ComingSoonProps) {
  const role = useDemoStore((s) => s.activeRole);
  return (
    <AppLayout pageTitle={title} breadcrumb={[role, title]}>
      <div
        style={{
          maxWidth: 720,
          margin: "48px auto",
          background: "white",
          border: "1px solid var(--cc-gray-200)",
          borderRadius: 14,
          padding: 36,
          textAlign: "center",
        }}
        data-testid={`coming-soon-${module}`}
      >
        <div
          style={{
            width: 56, height: 56, borderRadius: 14,
            background: "var(--cc-teal-bg)",
            color: "var(--cc-teal)",
            display: "inline-flex", alignItems: "center", justifyContent: "center",
            marginBottom: 18,
          }}
        >
          <Construction size={26} />
        </div>
        <div style={{ fontSize: 11, fontWeight: 700, color: "var(--cc-teal)", letterSpacing: "0.08em", textTransform: "uppercase", marginBottom: 8 }}>
          Módulo {module}
        </div>
        <h1 style={{ fontSize: 22, fontWeight: 700, color: "var(--cc-gray-900)", margin: "0 0 10px" }}>{title}</h1>
        <p style={{ fontSize: 14, color: "var(--cc-gray-600)", lineHeight: 1.55, margin: "0 0 22px" }}>
          {description ??
            "Esta vista se conecta al store funcional pero su pantalla de detalle se entregará en la siguiente tarea del plan. Los datos ya están persistidos y disponibles para los demás módulos."}
        </p>
        <Link
          href={roleHomes[role]}
          style={{
            display: "inline-flex", alignItems: "center", gap: 8,
            padding: "8px 14px", borderRadius: 8,
            background: "var(--cc-gray-100)",
            color: "var(--cc-gray-700)", fontSize: 13, fontWeight: 600,
            textDecoration: "none",
          }}
          data-testid="link-back-home"
        >
          <ArrowLeft size={14} />
          Volver al panel
        </Link>
      </div>
    </AppLayout>
  );
}
